var jquery = require("jquery");

export default (window.$ = window.jQuery = jquery);
